import { Box, Card, Divider, Stack } from 'braid-design-system';

import { SkeletonBlock } from '../SkeletonBlock/SkeletonBlock';

export const SkeletonEditUserPermissions = () => (
  <Box aria-label="Loading user permissions">
    <Card>
      <Stack space="large">
        <SkeletonBlock variant="standard" width="small" height="standard" />
        <Stack space="small">
          <SkeletonBlock variant="standard" width="xsmall" height="standard" />
          <SkeletonBlock variant="standard" width="small" height="standard" />
          <SkeletonBlock variant="standard" width="small" height="standard" />
        </Stack>
        <Divider />
        <SkeletonBlock variant="standard" width="small" height="standard" />
        <Stack space="small">
          <SkeletonBlock variant="standard" width="xsmall" height="standard" />
          <SkeletonBlock variant="standard" width="small" height="standard" />
        </Stack>
        <Stack space="small">
          <SkeletonBlock variant="standard" width="xsmall" height="standard" />
          <SkeletonBlock variant="standard" width="small" height="standard" />
          <SkeletonBlock variant="standard" width="small" height="standard" />
        </Stack>
        <Stack space="small">
          <SkeletonBlock variant="standard" width="xsmall" height="standard" />
          <SkeletonBlock variant="standard" width="small" height="standard" />
        </Stack>
      </Stack>
    </Card>
  </Box>
);

export const SkeletonEditUserDetails = () => (
  <Box aria-label="Loading user details">
    <Card>
      <Stack space="large">
        <SkeletonBlock variant="standard" width="small" height="standard" />
        <Stack space="small">
          <SkeletonBlock variant="standard" width="xsmall" height="standard" />
          <SkeletonBlock variant="standard" width="medium" height="standard" />
        </Stack>
        <Stack space="small">
          <SkeletonBlock variant="standard" width="xsmall" height="standard" />
          <SkeletonBlock variant="standard" width="medium" height="standard" />
        </Stack>
      </Stack>
    </Card>
  </Box>
);
